<template>
  <div class="pro-eti">
    <!-- SETA O STATUS DE CARREGANDO DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else>
      <!-- SETA O ALERTA -->
      <div v-if="[ '', null, undefined ].indexOf(alerta) === -1" v-html="alerta" class="app-message-alert app-message-alert--danger" style="margin: 5px 10px 10px 10px; padding: 5px 10px;"></div>

      <!-- SETA OS DADOS DO PDF -->
      <embed v-if="[ '', null, undefined ].indexOf(etiqueta) === -1" :src="'data:application/pdf;base64, ' + etiqueta" width="100%" height="100%" style="height: 100vh;" type="application/pdf">
    </div>
  </div>
</template>

<style socped>
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntModelo: {
        type: String,
        required: true
      },
      cpntEtiquetaExemplo: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      },
      cpntEtiquetas: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },

      cpntIniciarColuna: {
        type: [ Number, String ],
        required: false,
        default: function () {
          return 1
        }
      },
      cpntOnFecharDialog: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        etiqueta: '',
        alerta: null
      }
    },
    mounted: function () {
      this.proEtiIniciar()
    },
    methods: {
      proEtiIniciar: function () {
        // SETA OS STATUS DA TELA
        this.proEtiSetarStatusGeral('carregando')

        // INICIA A QUERY QUE SERÁ FEITA
        var formData = {}

        // SETA O MODELO RECEBIDO
        formData.id_modelo = this.cpntModelo

        // SETA O INICIO DO PROCESSO
        formData.a_partir_coluna = this.cpntIniciarColuna.toString()

        // SETA AS INFORMAÇÕES DE EXEMPLO
        if (Object.keys(this.cpntEtiquetaExemplo).length >= 1) {
          formData.j_quantidade = JSON.parse(JSON.stringify([ this.cpntEtiquetaExemplo ]))
        } else {
          formData.j_quantidade = this.cpntEtiquetas
        }

        // CONVERTE PARA STRING
        formData.j_quantidade = JSON.stringify(formData.j_quantidade)
            
        // FAZ A BUSCA DOS DADOS NA API
        this.$store.state.comunicaAPI('/etiqueta/gerar/get', 'POST', formData, (retorno) => {
          if ([ '', null, undefined ].indexOf(retorno.string) === -1) {
            // SETA O CONTEUDO DO ARQUIVO
            this.etiqueta = retorno.string
  
            // SETA A VARIAVEL
            this.alerta = [ '', null, undefined ].indexOf(retorno.alert) === -1 ? retorno.alert : null
  
            // SETA OS STATUS DA TELA
            this.proEtiSetarStatusGeral('')
          } else if (this.cpntOnFecharDialog !== null) {
            this.cpntOnFecharDialog()
          }
        }, (apiError, retorno) => {
          // SETA A VARIAVEL
          this.alerta = [ '', null, undefined ].indexOf(retorno.message) === -1 ? retorno.message : null

          // SETA O CONTEUDO DO ARQUIVO
          this.etiqueta = null

          // APRESENTA O ERRO NA TELA
          this.proEtiSetarStatusGeral(apiError)

          // FECHA A DIALOG
          if (this.cpntOnFecharDialog !== null) {
            this.cpntOnFecharDialog()
          }
        })
      },
      proEtiSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    // watch: {
    //   cpntEtiquetaExemplo: function () {
    //     this.proEtiIniciar()
    //   }
    // }
  }
</script>
